import { registerAction } from '../../Action'

const LOAD_ASSETS = 'LOAD_ASSETS'

const reducer = (state = {}, action) => ({
  ...state,
  assets: action.payload,
  assetsLoaded: true,
})

const loadContent = registerAction(LOAD_ASSETS, { reducer })

export default loadContent
